import React, { FunctionComponent } from "react";
import { TimeInput, TimePrecision } from "@plex/react-components";
import { DateTimeFormatStyle } from "@plex/culture-core";
import { INodeConfigPropertiesProps } from "../NodeTypes/PropertyTypeDefinitions";

export interface ITimeInputProps extends INodeConfigPropertiesProps {
  label: string;
  formatOptions: DateTimeFormatStyle;
  precision: TimePrecision;
}

export const TimeFormField: FunctionComponent<ITimeInputProps> = (props) => {
  const [value, setValue] = React.useState(null);

  const handleValueChange = (newTemporalValue: any) => {
    props.node!.data.nodeProperties[props.name] = newTemporalValue?._time?.withSecond(0)?.withNano(0)?.toString() || newTemporalValue?.withSecond(0)?.withNano(0)?.toString();
    setValue(newTemporalValue?._time || newTemporalValue);
    props.forceNodeUpdate();
  };

  return (
    <TimeInput
      key={`${props.sectionName} ${props.label} Input`}
      value={value}
      onValueChange={handleValueChange}
      formatOptions={props.formatOptions}
      use24HourTime={false}
      precision={props.precision}
      minuteStep={1}
    />
  );
};
